import { FC } from 'react';

import './Loader.scss';

enum LoaderColor {
  white = 'white',
  black = 'black',
}

interface Props {
  color?: keyof typeof LoaderColor;
}

export const Loader: FC<Props> = ({ color }) => {
  return <span className={`loader loader-${color ? color : LoaderColor.white}`}></span>;
};
